import React from "react";
import { Send } from "lucide-react";
import { ReadableNavButton } from "../Sticker";

export default function NotifyRow({ name, meta, whatsappUrl, testId, pingTestId }) {
  return (
    <div
      className="rounded-md2 border border-black/[0.08] p-3 flex items-center gap-3 bg-white"
      data-testid={testId}
    >
      <div className="rounded-pill w-9 h-9 flex items-center justify-center font-ui font-semibold text-[14px] bg-cream shrink-0" aria-hidden>
        {(name?.[0] || "?").toUpperCase()}
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-ui font-semibold text-[15px] truncate" title={name || undefined}>{name}</p>
        <p className="font-ui font-medium text-[12px] text-ink/60 truncate" title={meta || undefined}>{meta}</p>
      </div>
      {whatsappUrl ? (
        <ReadableNavButton
          as="a"
          href={whatsappUrl}
          target="_blank"
          rel="noreferrer"
          variant="primary"
          className="px-3 shrink-0"
          data-testid={pingTestId}
        >
          <Send className="w-4 h-4" strokeWidth={2.5} aria-hidden />
          Ping on WhatsApp
        </ReadableNavButton>
      ) : null}
    </div>
  );
}
